import * as React from 'react';
import {Mutation} from 'react-apollo';

import {CheckboxButton} from 'shells/button/checkbox-button/checkbox-button';

import type {
    Lead as LeadFragment,
    LeadSetWatched as LeadSetWatchedMutation,
    LeadSetWatchedVariables as LeadSetWatchedMutationVariables,
} from 'nutshell-graphql-types';

import LEAD_SET_WATCHED from '../../../shared/graphql/mutations/lead-set-watched.graphql';

class WatchMutation extends Mutation<LeadSetWatchedMutation, LeadSetWatchedMutationVariables> {}

type Props = {
    lead: LeadFragment;
};
export function WatchButton(props: Props) {
    return (
        <WatchMutation mutation={LEAD_SET_WATCHED}>
            {(setWatched, {loading}) => (
                <CheckboxButton
                    label='Watching'
                    disabled={loading}
                    checked={props.lead.isCurrentUserWatching}
                    onChange={(isChecked) => {
                        setWatched({
                            variables: {lead: {id: props.lead.id, shouldWatch: isChecked}},
                            optimisticResponse: {
                                // @ts-expect-error
                                __typename: 'Mutation',
                                leadSetWatched: {
                                    __typename: 'LeadSetWatchedPayload',
                                    lead: {
                                        // @ts-expect-error
                                        __typename: 'Lead',
                                        ...props.lead,
                                        isCurrentUserWatching: isChecked,
                                    },
                                },
                            },
                        });
                    }}
                />
            )}
        </WatchMutation>
    );
}
